/*
 * @Author: Teemo Ding
 * @Date: 2021-09-01 16:19:08
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-16 13:07:15
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/FlashSale/Components/FlashSaleDiscount/index.tsx
 */
import { OriNumberInput } from '@/src/components/Antd';
import { RadioGroup, RadioItem } from '@/src/components/Antd/Radio/Radio';
import { get } from 'lodash';
import React from 'react';
import { EnumMode } from 'src/components/Antd/NumberInput/NumberInput';
import css from './css.module.less';

// interface RadioValue {

// }

interface RadioList {
  value: string;
  label: string;
  suffix: string;
  inputKey: string;
  mode?: EnumMode;
  min?: number;
  max?: number;
}

interface IProps {
  radioList: RadioList[];
  value?: any;
  radioKey: string;
  id?: string;
  disableEdit?: boolean;
  onChange?: (any) => void;
}

const FlashSaleDiscount = ({
  radioList,
  value,
  radioKey,
  id,
  disableEdit,
  onChange,
}: IProps) => {
  const triggerChange = (changedValue) => {
    if (onChange) {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  const handleRadioOnChange = (value: any) => {
    triggerChange({ [radioKey]: value });
  };

  const handleInputOnchange = (inputKey, value: any) => {
    triggerChange({ [inputKey]: value });
  };

  return (
    <div id={id}>
      <RadioGroup
        value={get(value, [radioKey], '')}
        className={css.radioGroup}
        onChange={(value) => handleRadioOnChange(value.target.value)}
        disabled={disableEdit}>
        {radioList.map((it, index) => (
          <div className={css.radioItem} key={index}>
            <RadioItem key={it.value} value={it.value}>
              {it.label}{' '}
            </RadioItem>
            {get(value, [radioKey], '') == it.value && (
              <div className={css.input}>
                <OriNumberInput
                  value={get(value, [it.inputKey], '')}
                  onChange={(value) => handleInputOnchange(it.inputKey, value)}
                  size='large'
                  suffix={it.suffix}
                  mode={it.mode}
                  max={it.max}
                  min={it.min}
                  disabled={disableEdit}
                />
              </div>
            )}
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};

export default FlashSaleDiscount;
